const { formatMoney } = window.BAO.Utils;

class Cache {
  constructor() {
    /** @type {Map<String, String>} */
    this.cache = new Map();
  }

  exists(key) {
    return this.cache.has(key);
  }

  /**
   * @param {String} key
   * @param {String} value
   */
  set(key, value) {
    this.cache.set(key, value);
  }

  /**
   * @param {String} key
   */
  get(key) {
    return this.cache.get(key);
  }

  delete(key) {
    this.cache.delete(key);
  }
}

export class LoyaltyPointsOrder extends window.BAO.CustomElement() {
  static get requiredAttributes() {
    return ["data-country-code", "data-cart-amount"];
  }

  constructor() {
    super();

    this.cache = new Cache();
  }

  connectedCallback() {
    super.connectedCallback();
    this.handleCustomerDetails();

    this.moneyFormat = window.theme.moneyFormat;
  }

  setupListeners() {
    super.setupListeners();

    this.handleCustomerDetails = this.handleCustomerDetails.bind(this);

    if (typeof window.jQuery === "undefined") {
      document.addEventListener("swell:setup", () => {
        this.handleCustomerDetails();
        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.CHANGED,
          this.handleCustomerDetails
        );
      });
    } else {
      window.jQuery(document).on("swell:setup", () => {
        this.handleCustomerDetails();
        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PUSH_CART.CHANGED,
          this.handleCustomerDetails
        );
      });
    }
  }

  async handleCustomerDetails() {
    this.swellAPI = window.swellAPI;
    this.swellConfig = window.swellConfig;

    if (!this.swellAPI || !this.swellConfig) return;

      try {
        const cart = await this.getCartData();
        const cartPrice = cart.total_price;

        if (!cartPrice) return;

        if (this.moneyFormat.indexOf("amount_no_decimals") === -1) {
          this.moneyFormat = this.moneyFormat.replace(
            "amount",
            "amount_no_decimals"
          );
        }

        const formattedCartPrice = formatMoney(cartPrice, this.moneyFormat);
        const formattedPointsCartPrice = formattedCartPrice.replace(/[^\d.]/g, "");

        this.showPointsAmount(parseFloat(formattedPointsCartPrice));
      } catch (error) {
        console.error("Failed to fetch cart data:", error);
      }
  }

  async getCartData() {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    return cart;
  }

  showPointsAmount(amount) {
    const pointsMultiplier = !isNaN(
      this.swellConfig?.customer?.vip_tier?.points_multiplier
    )
      ? this.swellConfig?.customer?.vip_tier?.points_multiplier
      : window.theme.pointsMultiplier;
    this.textContent = ((amount ?? 0.0 / 100) * pointsMultiplier).toString();
  }

  /**
   * @param {RequestInit} options
   */

  getCacheKey() {
    return `${this.countryCode}-${this.productHandle}`;
  }

  get countryCode() {
    return this.dataset.countryCode;
  }
}

if (!customElements.get("loyalty-points-order")) {
  customElements.define("loyalty-points-order", LoyaltyPointsOrder);
}
